import Link from 'next/link'
import CommonPopover from './CommonPopover'
import {
  tipsy_facebook,
  tipsy_ins,
  tipsy_tiktok,
  tipsy_twitter,
  tipsy_youtube,
} from '@/constant/contact'
import { NavTwitterIcon } from '../svg/NavTwitterIcon'
import { LeftOutlinedIcon } from '@/icons'
import { InstagramIcon } from '../svg/InstagramIcon'
import { TikTokIcon } from '../svg/TikTokIcon'
import { YouTubeIcon } from '../svg/YoutubeIcon'
import { FacebookIcon } from '../svg/FacebookIcon'
import ChatMoreIcon from '../svg/ChatMoreIcon'

const FollowUsPopover = () => {
  return (
    <CommonPopover
      trigger="click"
      overlayInnerStyle={{
        marginTop: '8px',
        background:
          'linear-gradient(180deg, rgba(24,14,31,0.75) 0%, rgba(65,35,77,0.72) 50%, rgba(29,21,21,0.75) 100%)',
        backgroundColor: 'rgba(0,0,0,0.2)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        willChange: 'backdrop-filter',
        transform: 'translateZ(0)',
        border: '1px solid rgba(255,255,255,0.2)',
        padding: '0',
        borderRadius: '10px',
        opacity: '1',
      }}
      content={
        <div className="justify-items-stretch divide-y divide-white/10 overflow-hidden rounded-[10px] bg-white/5 opacity-70 shadow-[0_0_1px_0_rgba(255,255,255,0.18)]">
          <Link
            href={tipsy_twitter}
            target="_blank"
            prefetch
            className="flex h-[50px] cursor-pointer items-center justify-between px-2.5 text-[13px] hover:bg-white/10"
          >
            <NavTwitterIcon className="mx-1.5" />
            <span className="text-white">Twitter</span>
            <div className="ml-1.5 rotate-180">
              <LeftOutlinedIcon />
            </div>
          </Link>
          <Link
            href={tipsy_ins}
            target="_blank"
            prefetch
            className="flex h-[50px] cursor-pointer items-center justify-between px-2.5 text-[13px] hover:bg-white/10"
          >
            <InstagramIcon size={24} className="mx-1.5" />
            <span className="text-white">Instagram</span>
            <div className="ml-1.5 rotate-180">
              <LeftOutlinedIcon />
            </div>
          </Link>
          <Link
            href={tipsy_tiktok}
            target="_blank"
            prefetch
            className="flex h-[50px] cursor-pointer items-center justify-between px-2.5 text-[13px] hover:bg-white/10"
          >
            <TikTokIcon size={24} className="mx-1.5" />
            <span className="text-white">Tiktok</span>
            <div className="ml-1.5 rotate-180">
              <LeftOutlinedIcon />
            </div>
          </Link>
          <Link
            href={tipsy_youtube}
            target="_blank"
            prefetch
            className="flex h-[50px] cursor-pointer items-center justify-between px-2.5 text-[13px] hover:bg-white/10"
          >
            <YouTubeIcon size={24} className="mx-1.5" />
            <span className="text-white">Youtube</span>
            <div className="ml-1.5 rotate-180">
              <LeftOutlinedIcon />
            </div>
          </Link>
          <Link
            href={tipsy_facebook}
            target="_blank"
            prefetch
            className="flex h-[50px] cursor-pointer items-center justify-between px-2.5 text-[13px] hover:bg-white/10"
          >
            <FacebookIcon size={24} className="mx-1.5" />
            <span className="text-white">Facebook</span>
            <div className="ml-1.5 rotate-180">
              <LeftOutlinedIcon />
            </div>
          </Link>
        </div>
      }
    >
      <ChatMoreIcon className="rotate-90 cursor-pointer" />
    </CommonPopover>
  )
}

export default FollowUsPopover
